<template>
  <div class="viewContainer">
    <div class="Toolbar">
      <div class="Toolbar-Left cursorPointer" @click="_onClickGoBack">
        <font-awesome-icon :icon="['fal', 'angle-left']" size="2x" />
        <span class="u-ml10 TextWithIcon">得意先一覧</span>
      </div>
    </div>

    <el-row :gutter="20">
      <el-col :span="14" :offset="2">
        <h2>ユーザー編集</h2>
      </el-col>
      <el-col :span="14" :offset="2">
        <!-- Forms -->
        <el-form :model="userEditForm" ref="items" label-width="120px">
          <!-- Name Form -->
          <el-form-item
            label="お名前"
            prop="name"
            :rules="[{ required: true, message: 'お名前は必須の項目です' }]"
          >
            <el-input
              placeholder="名前"
              v-model="userEditForm.name"
              class="e-input"
            ></el-input>
          </el-form-item>

          <!-- ID Form -->
          <el-form-item
            label="メールアドレス"
            prop="id"
            :rules="[
              { required: true, message: 'メールアドレスは必須の項目です' }
            ]"
          >
            <el-input
              placeholder="xxx@xxx.com"
              v-model="userEditForm.id"
              class="e-input"
            ></el-input>
          </el-form-item>

          <!-- Password Form -->
          <el-form-item
            label="パスワード"
            prop="id"
            :rules="[{ required: true, message: 'パスワードは必須の項目です' }]"
          >
            <el-input
              placeholder="******"
              v-model="userEditForm.password"
              class="e-input"
            ></el-input>
          </el-form-item>

          <!-- Role Form -->
          <el-form-item
            label="役割"
            prop="role"
            :rules="[{ required: true, message: '役割は必須の項目です' }]"
          >
            <el-radio-group v-model="userEditForm.role">
              <el-radio label="USER">得意先</el-radio>
              <el-radio label="ADMIN">管理者</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- Actions -->
          <el-form-item>
            <div class="u-flex">
              <div class="u-flex u-grow">
                <el-button @click="_onClickCancel">キャンセル</el-button>
                <el-button type="primary" @click="_onClickSave">保存</el-button>
              </div>
              <div class="u-flex u-grow u-jce">
                <el-button type="danger" @click="_onClickDelete"
                  >削除</el-button
                >
              </div>
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// Usecase Dependencies
import UsecaseFactory from "@/usecases/usecase.factory.js";
const userUsecase = UsecaseFactory.create("user");

// Components Dependencies
// import RequiredLabel from "@/components/RequiredLabel";

export default {
  components: {
    // RequiredLabel
  },
  data () {
    return {
      userEditForm: {
        name: "",
        id: "",
        password: "",
        role: "USER",
      },
    };
  },
  methods: {
    _onClickGoBack () {
      this.goBack();
    },
    _onClickCancel () {
      this.goBack();
    },
    _onClickSave () {
      // TODO
      try {
        userUsecase.create();
      } catch (err) {
        console.error(err);
      }
      this.goBack();
    },
    _onClickDelete () {
      this.$confirm("本当に削除しますか")
        .then(() => {
          try {
            userUsecase.delete();
          } catch (err) {
            console.error(err);
          }
          this.goBack();
        })
        .catch(() => {});
    },
    goBack () {
      const { $router } = this;
      $router.push("/admin/users");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.container {
  display: flex;
  height: 100%;
}
.column {
  height: 100%;
  flex: 2;
}

.column--right {
  flex: 1;
  border-left: 1px solid $--border-color-lighter;
}

.Toolbar {
  display: flex;
  align-items: center;
  padding: 10px;
}

.Toolbar-Left {
  flex: 1;
  justify-content: center;
  align-items: center;
}

.Toolbar-Center {
  flex: 1;
  justify-content: center;
  align-items: center;
}

.Toolbar-Right {
  flex: 1;
  text-align: right;
}
</style>
